module.exports = __webpack_public_path__ + "img/traditional vampire costumes.34dc9bd2.png";